export default __webpack_public_path__ + "static/media/minimalart.a5bef678.png";